import { apiGet } from "@redriver/cinnamon";

const NAMESPACE = "TRAVEL";
const ActionTypes = {
  GetItineraryList: `${NAMESPACE}/GET_ITINERARY_LIST`,
};

export const getItineraryList = (
  { pagination },
  { departureDateFrom, departureDateTo }
) => {
  const { pageSize, pageNumber } = pagination;
  return apiGet(ActionTypes.GetItineraryList, `resort-reps/itineraries`, {
    viewName: "ResortRepItineraryPortalListView",
    pageNumber,
    pageSize,
    departureDateFrom,
    departureDateTo,
  });
};
